module.exports = __webpack_public_path__ + "static/media/10387558_690536631012677_1652084844158464187_n.8d96bce4.jpg";